import { Navbar, Hero, Services, Realisations, RGE, Booking, ContactForm, Footer } from '../../components';

export const BaseApp = () => (
  <>
    <Navbar />
    <Hero />
    <Services />
    <Realisations />
    <RGE />
    <Booking />
    <ContactForm />
    <Footer />
  </>
);

export default BaseApp;
